import React, { useState } from 'react';
import {
    Box,
    Typography,
    Modal,
    TextField,
    Button,
    MenuItem,
    IconButton,
    Divider,
    Grid,
    Paper,
    useMediaQuery
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const defaultProposals = [
    {
        date: '2025-06-15',
        startTime: '06:00',
        endTime: '09:00',
        venue: 'Glendale Rec Center',
        address: '123 N Main St, Glendale, CA',
        latitude: 34.1446,
        longitude: -118.2568,
        sport: 'Basketball',
        notes: 'Users prefer Tuesday mornings based on submitted preferences.'
    },
    {
        date: '2025-06-15',
        startTime: '06:00',
        endTime: '09:00',
        venue: 'Glendale Rec Center',
        address: '123 N Main St, Glendale, CA',
        latitude: 34.1446,
        longitude: -118.2568,
        sport: 'Basketball',
        notes: 'Users prefer Thursday mornings based on submitted preferences.'
    }
];

const ProposeSessionModal = ({ open, onClose }) => {
    const [proposals, setProposals] = useState(defaultProposals);
    const isMobile = useMediaQuery('(max-width:600px)');

    const handleChange = (index, field) => (event) => {
        const newProposals = [...proposals];
        newProposals[index][field] = event.target.value;
        setProposals(newProposals);
    };

    const handleRemove = (index) => {
        const newProposals = proposals.filter((_, i) => i !== index);
        setProposals(newProposals);
    };

    const handleAddProposal = () => {
        setProposals(prev => [
            ...prev,
            {
                date: '2025-06-15',
                startTime: '06:00',
                endTime: '09:00',
                venue: 'Glendale Rec Center',
                address: '123 N Main St, Glendale, CA',
                latitude: 34.1446,
                longitude: -118.2568,
                sport: 'Basketball',
                notes: 'Users prefer [Day] mornings based on AI heatmap.'
            }
        ]);
    };

    const handleSubmit = () => {
        console.log('✅ Proposed Sessions:', proposals);
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose} sx={{ zIndex: 2600 }}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: '#202020',
                    padding: '2rem',
                    borderRadius: 2,
                    boxShadow: 24,
                    width: isMobile ? '95vw' : 680,
                    color: '#fff',
                    maxHeight: '90vh',
                    overflowY: 'auto'
                }}
            >

                <Typography variant="h6" gutterBottom>Propose New Session(s)</Typography>
                <Divider sx={{ mb: 2, borderColor: '#333' }} />

                {proposals.map((proposal, index) => (
                    <Paper key={index} sx={{ backgroundColor: '#181818', p: 2, mb: 3 }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="subtitle1" sx={{ color: '#12c099' }}>
                                Proposal #{index + 1}
                            </Typography>
                            <IconButton size="small" onClick={() => handleRemove(index)} sx={{ color: '#888' }}>
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Box>

                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    type="date"
                                    label="Date"
                                    value={proposal.date}
                                    onChange={handleChange(index, 'date')}
                                    InputLabelProps={{ shrink: true }}
                                    sx={{ input: { color: '#fff' }, label: { color: '#aaa' } }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="time"
                                            label="Start Time"
                                            value={proposal.startTime}
                                            onChange={handleChange(index, 'startTime')}
                                            InputLabelProps={{ shrink: true }}
                                            sx={{
                                                minWidth: '100%',
                                                input: { color: '#fff', fontSize: 14 },
                                                label: { color: '#aaa' }
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="time"
                                            label="End Time"
                                            value={proposal.endTime}
                                            onChange={handleChange(index, 'endTime')}
                                            InputLabelProps={{ shrink: true }}
                                            sx={{
                                                minWidth: '100%',
                                                input: { color: '#fff', fontSize: 14 },
                                                label: { color: '#aaa' }
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Venue"
                                    value={proposal.venue}
                                    onChange={handleChange(index, 'venue')}
                                    sx={{ label: { color: '#aaa' }, '.MuiSelect-select': { color: '#fff' } }}
                                >
                                    {[ 'Glendale Rec Center', 'Pasadena Gym', 'Hollywood Athletic Club', 'Silverlake Sports Complex', 'Burbank Field House', 'Downtown YMCA' ].map((venue) => (
                                        <MenuItem key={venue} value={venue}>{venue}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    select
                                    label="Sport"
                                    value={proposal.sport}
                                    onChange={handleChange(index, 'sport')}
                                    sx={{ label: { color: '#aaa' }, '.MuiSelect-select': { color: '#fff' } }}
                                >
                                    {[ 'Basketball', 'Soccer', 'Volleyball', 'Football', 'Boxing', 'Dance', 'Tennis', 'Lacrosse', 'Dodgeball' ].map((sport) => (
                                        <MenuItem key={sport} value={sport}>{sport}</MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Notes"
                                    multiline
                                    rows={2}
                                    value={proposal.notes}
                                    onChange={handleChange(index, 'notes')}
                                    sx={{ textarea: { color: '#fff' }, label: { color: '#aaa' } }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                ))}

                <Box display="flex" justifyContent="space-between" mt={2} flexDirection={isMobile ? 'column' : 'row'} gap={2}>
                    <Button
                        variant="outlined"
                        onClick={handleAddProposal}
                        sx={{ color: '#12c099', borderColor: '#12c099' }}
                    >
                        + Add Proposal
                    </Button>
                    <Box display="flex" gap={2} justifyContent="flex-end">
                        <Button variant="outlined" color="error" onClick={onClose}>Cancel</Button>
                        <Button variant="outlined" sx={{ borderColor: '#12c099', color: '#12c099' }} onClick={handleSubmit}>
                            Submit All
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default ProposeSessionModal;
